import { formatCurrency, pn, Typography } from "@compass/core";
import { DevExpressReport } from "components";
import { Column } from "devextreme-react/data-grid";
import { MatchReportActualMatch, MatchReportActualMatchRow } from "generated/openApi";

export const ActualMatch = (props: { report: MatchReportActualMatch }) => {
  return (
    <DevExpressReport
      dataSource={props.report.rows}
      fullPageSize
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={() => {
        return {
          header: "Match Actual Match",
          filename: "MatchActualMatch",
          tenantName: props.report.tenantName,
          infoTuples: [
            ["Date From", props.report.dateFrom ? new Date(props.report.dateFrom).toDateString() : undefined],
            ["Date To", props.report.dateTo ? new Date(props.report.dateTo).toDateString() : undefined],
            ["Status", props.report.reviewName],
          ],
        };
      }}
    >
      <Column
        dataField={`${pn<MatchReportActualMatchRow>("name")}`}
        caption="Category"
        defaultSortOrder="asc"
        cellRender={(data) => <Typography fontWeight={data.data.isBold ? "bold" : ""}>{data.text}</Typography>}
      />
      <Column
        dataField={pn<MatchReportActualMatchRow>("amount")}
        cellRender={(data) => (
          <Typography fontWeight={data.data.isBold ? "bold" : ""}>{formatCurrency(Number(data.text))}</Typography>
        )}
      />
    </DevExpressReport>
  );
};
